import { DeviceBreakpointsTypeUtils } from '../../types/breakpoints/breakpoints';
import { useMediaDevice } from './useMediaDevice';
export const useActiveBreakpoints = () => {
    const device = useMediaDevice();
    return {
        isMobile: DeviceBreakpointsTypeUtils.isMobile(device),
        isTablet: DeviceBreakpointsTypeUtils.isTablet(device),
        isMobileOrTablet: DeviceBreakpointsTypeUtils.isMobileOrTablet(device),
        isDesktop: DeviceBreakpointsTypeUtils.isDesktop(device),
        isLargeDesktop: DeviceBreakpointsTypeUtils.isLargeDesktop(device),
        isDesktopOrLargeDesktop: DeviceBreakpointsTypeUtils.isDesktopOrLargeDesktop(device),
        device,
    };
};
//# sourceMappingURL=useActiveBreakpoints.js.map